import api from "./api";

const programPatientService = {};
const endpoint = "/program-patients";

programPatientService.getProgramPatients = function (params = {}) {
  return api.get(endpoint, { params }).then((res) => res.data);
};

programPatientService.getProgramPatientsByPatientId = function (
  patientId,
  options = {}
) {
  return api
    .get(`${endpoint}/patient/${patientId}`, options)
    .then((res) => res.data);
};

programPatientService.assignProgramToPatient = function (programPatientData) {
  return api.post(endpoint, programPatientData).then((res) => res.data);
};

programPatientService.updateProgramPatientStatus = function (
  id,
  status,
  payload = {}
) {
  return api
    .put(`${endpoint}/${id}`, { status, ...payload })
    .then((res) => res.data);
};

programPatientService.requestAdditionalInformation = function (
  id,
  description
) {
  return api
    .put(`${endpoint}/${id}/request-additional-info`, { description })
    .then((res) => res.data);
};

programPatientService.completeAdditionalInformation = function (id) {
  return api
    .put(`${endpoint}/${id}/complete-additional-info`)
    .then((res) => res.data);
};

export default programPatientService;
